/**
 * frontend/src/shared/utils/persian.ts
 * ─────────────────────────────────────
 * Normalise Arabic ي (U+064A) → Persian ی (U+06CC)
 *            Arabic ك (U+0643) → Persian ک (U+06A9)
 *
 * Used in the Axios request interceptor so every outgoing request
 * (search queries, form data, JSON bodies) uses canonical Persian chars.
 */

/**
 * Replace Arabic ي/ك with their Persian equivalents.
 */
export function normalizePersian(text: string): string {
  return text
    .replace(/\u064A/g, "\u06CC")   // ي → ی
    .replace(/\u0643/g, "\u06A9");  // ك → ک
}

/**
 * Recursively normalise all string values inside an object / array.
 */
export function normalizeDeep<T>(value: T): T {
  if (typeof value === "string") {
    return normalizePersian(value) as unknown as T;
  }
  if (Array.isArray(value)) {
    return value.map(normalizeDeep) as unknown as T;
  }
  if (value !== null && typeof value === "object") {
    const result: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value)) {
      result[k] = normalizeDeep(v);
    }
    return result as T;
  }
  return value;
}
